// Results Styles
// Styled components for results and insights

import styled from 'styled-components';
import { theme } from '../theme';

export const ResultsContainer = styled.div`
  background: ${theme.colors.background.primary};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.lg};
  box-shadow: ${theme.shadows.light};
  min-height: 400px;
  display: flex;
  flex-direction: column;

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
    min-height: 300px;
  }
`;

export const HeartProfileHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing.lg};
`;

export const HeartProfileType = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.sm} 0;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee4d4d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const HeartProfileDescription = styled.p`
  font-size: 1.125rem;
  color: ${theme.colors.text.secondary};
  margin: 0;
  line-height: 1.6;
`;

export const HeartProfileConfidence = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  background: ${theme.colors.background.secondary};
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.sm};
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin-top: ${theme.spacing.sm};
`;

export const TraitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.lg};
`;

export const TraitCard = styled.div`
  background: ${theme.colors.background.secondary};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
  text-align: center;
`;

export const TraitName = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.sm};
`;

export const TraitValue = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.sm};
`;

export const TraitDescription = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin: 0;
  line-height: 1.5;
`;

export const InsightsSection = styled.div`
  margin-bottom: ${theme.spacing.lg};
`;

export const InsightsTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.md} 0;
`;

export const InsightsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const InsightItem = styled.li`
  background: ${theme.colors.background.secondary};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.sm};
  border-left: 4px solid ${theme.colors.primary};
`;

export const InsightText = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin: 0;
  line-height: 1.5;
`;

export const RecommendationsSection = styled.div`
  margin-bottom: ${theme.spacing.lg};
`;

export const RecommendationsTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.md} 0;
`;

export const RecommendationsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const RecommendationItem = styled.li`
  background: ${theme.colors.background.secondary};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.sm};
  border-left: 4px solid ${theme.colors.secondary};
`;

export const RecommendationTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.xs};
`;

export const RecommendationText = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin: 0;
  line-height: 1.5;
`;

export const CompatibilitySection = styled.div`
  margin-bottom: ${theme.spacing.lg};
`;

export const CompatibilityTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.md} 0;
`;

export const CompatibilityGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${theme.spacing.md};
`;

export const CompatibilityCard = styled.div`
  background: ${theme.colors.background.secondary};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
  text-align: center;
`;

export const CompatibilityType = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.sm};
`;

export const CompatibilityScore = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.sm};
`;

export const CompatibilityDescription = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin: 0;
  line-height: 1.5;
`;

export const ResultsActions = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  justify-content: center;
  margin-top: ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.mobile}) {
    /* Keep buttons centered in row or wrapped */
    flex-wrap: wrap; 
  }
`;









